import { render, staticRenderFns } from "./BotInfo.vue?vue&type=template&id=79c43ab0&scoped=true&lang=pug&"
import script from "./BotInfo.vue?vue&type=script&lang=ts&"
export * from "./BotInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BotInfo.vue?vue&type=style&index=0&id=79c43ab0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c43ab0",
  null
  
)

export default component.exports